import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { FETCH_DATA_SUCCESS } from '../reducers/fetchedData';
import setWrapperComponentName from '../utils/react/setWrapperComponentName';
import isUndefined from '../utils/type-check/isUndefined';

function mapStateToProps(state, ownProps) {
  return {
    data: state.fetchedData[ownProps.location.pathname],
    isMobile: state.deviceType.isMobile,
  };
}

const connectFetchedData = connect(mapStateToProps);

/**
 * @param {React.ComponentType} WrappedComponent
 * @param {(context: any) => Promise<any>} fetchData
 * @todo
 * - loading state
 * - api cache
 */
export default function withFetchData(WrappedComponent, fetchData) {
  function WithFetchData(props) {
    const { data, isMobile, dispatch, ...restProps } = props;

    const {
      match: { params },
      location: { search, pathname },
      history,
    } = props;

    const hasData = !isUndefined(data);
    const [isFetchingData, setIsFetchingData] = useState(!hasData);

    useEffect(() => {
      if (!hasData) {
        setIsFetchingData(true);

        const abortController = new AbortController();

        fetchData({
          signal: abortController.signal,
          dispatch,
          params,
          query: parse(search),
          isMobile,
        })
          .then(data => {
            dispatch({
              type: FETCH_DATA_SUCCESS,
              payload: {
                pathname,
                data: isUndefined(data) ? null : data,
              },
            });

            setIsFetchingData(false);
          })
          .catch(e => {
            history.replace('/maintain');
            console.error(e.message);
          });

        return () => {
          abortController.abort();
        };
      }
    }, [isMobile, dispatch, hasData, pathname, params, search, history]);

    return <WrappedComponent {...restProps} data={data} isFetchingData={isFetchingData}/>;
  }

  WithFetchData.fetchData = fetchData;
  setWrapperComponentName(WithFetchData, WrappedComponent);

  return connectFetchedData(WithFetchData);
}
